export default {
  brand: 'USFansLink',
  nav: {
    home: 'Strona główna',
    spreadsheet: 'Spreadsheet',
    categories: 'Kategorie',
    guide: 'Poradnik',
    safety: 'Bezpieczeństwo',
    shopGuide: 'Poradnik zakupowy',
  },
  hero: {
    eyebrow: 'Centrum zasobów USFans',
    title: 'USFans Spreadsheet — szybciej znajdź twórców, linki i zasoby',
    subtitle:
      'Poznaj uporządkowany zasób USFans spreadsheet z linkami do twórców, poradnikami wyszukiwania, porównaniami, aktualizacjami i informacjami o bezpieczeństwie — wszystko w jednym miejscu.',
    ctaPrimary: 'USFans Spreadsheet',
    ctaSecondary: 'Kup teraz',
    searchPlaceholder: 'Szukaj twórców USFans, linków, recenzji lub zasobów...',
    trust: 'Uporządkowane zasoby • Aktualne poradniki • Informacje o bezpieczeństwie',
  },
  category: {
    title: 'Przeglądaj według kategorii',
    subtitle:
      'Kupuj najnowsze kolekcje USFans — buty, odzież, akcesoria i więcej z naszego głównego sklepu.',
    dropdownLabel: 'Wybierz kategorię',
    dropdownPlaceholder: 'Wybierz kategorię, aby przejść...',
    viewCategory: 'Zobacz kategorię',
  },
  categories: {
    shoes: 'Buty',
    hoodies: 'Bluzy / Swetry',
    tshirts: 'Koszulki',
    jackets: 'Kurtki',
    pants: 'Spodnie / Szorty',
    headwear: 'Nakrycia głowy',
    sets: 'Zestawy',
    underwear: 'Bielizna / Majtki',
    jersey: 'Koszulki sportowe',
    accessories: 'Akcesoria',
    bags: 'Torby',
    belts: 'Paski',
    perfumes: 'Perfumy',
    other: 'Inne rzeczy',
  },
  valueProp: {
    title: 'Wszystko, czego potrzebujesz, aby poruszać się po zasobach USFans',
    cards: [
      { title: 'USFans Spreadsheet', text: 'Znajdź uporządkowane zasoby twórców i linki.' },
      { title: 'Wyszukiwanie twórców', text: 'Poznaj praktyczne metody wyszukiwania i researchu.' },
      { title: 'Recenzje i poradniki', text: 'Sprawdź recenzje, koszty, kupony, legalność i samouczki.' },
      { title: 'Centrum bezpieczeństwa', text: 'Dowiedz się, jak rozpoznawać podejrzane linki i chronić swoje dane.' },
    ],
  },
  core: {
    title: 'Czym jest USFans Spreadsheet?',
    copy: 'USFans Spreadsheet to uporządkowany zasób stworzony, aby ułatwić odkrywanie twórców USFans i research linków. Poznaj zorganizowane informacje, poradniki i przydatne zasoby z jednego centralnego miejsca.',
    tableHeaders: ['Twórca', 'Kategoria', 'Link', 'Status', 'Zaktualizowano'],
    tableRows: [
      ['Twórca Jeden', 'Buty', 'Zobacz', 'Aktywny', 'W tym tygodniu'],
      ['Twórca Dwa', 'Bluzy', 'Zobacz', 'Aktywny', 'W tym tygodniu'],
      ['Twórca Trzy', 'Koszulki', 'Zobacz', 'Aktywny', 'W zeszłym miesiącu'],
      ['Twórca Cztery', 'Koszulki sportowe', 'Zobacz', 'Aktywny', 'W zeszłym miesiącu'],
      ['Twórca Pięć', 'Akcesoria', 'Zobacz', 'Aktywny', 'W tym miesiącu'],
    ],
    cta: 'Otwórz USFans Spreadsheet',
  },
  intent: {
    title: 'Popularne tematy wyszukiwania',
    subtitle: 'Szybkie odpowiedzi na pytania, które ludzie najczęściej zadają o USFans.',
    cards: [
      'Recenzja USFans',
      'Koszt wysyłki USFans',
      'Kupon USFans',
      'Kod rabatowy USFans',
      'Magazyn USFans',
      'Czy USFans jest legalny?',
    ],
  },
  comparison: {
    title: 'Porównaj swoje opcje',
    subtitle: 'Wybierz podejście, które pasuje do tego, jak lubisz przeglądać i researchować.',
    headers: ['Zasób', 'Najlepszy do', 'Organizacja', 'Wyszukiwalność'],
    rows: [
      ['USFans Spreadsheet', 'Uporządkowany research', 'Wysoka', 'Wysoka'],
      ['Katalog', 'Przeglądanie', 'Średnia', 'Wysoka'],
      ['Wyszukiwanie ręczne', 'Szybki research', 'Niska', 'Średnia'],
    ],
  },
  safety: {
    title: 'Przeglądaj zasoby USFans bezpieczniej',
    copy: 'Weryfikuj domeny, unikaj podejrzanych przekierowań, nigdy nie udostępniaj haseł ani danych płatniczych, unikaj nieznanych pobrań, uważaj na phishing i szanuj prywatność twórców.',
    cta: 'Odwiedź Centrum bezpieczeństwa',
  },
  featuredGuide: {
    eyebrow: 'Polecany poradnik',
    title: 'USFans Spreadsheet: Kompletny przewodnik',
    excerpt:
      'Dowiedz się, czym jest USFans Spreadsheet, jak go używać do znajdowania twórców i linków oraz jak bezpiecznie przeglądać.',
    readMore: 'Przeczytaj poradnik',
  },
  pillar: {
    eyebrow: 'Biblioteka zasobów USFans',
    title: 'Poradniki USFans',
    subtitle: 'Szczegółowe zasoby obejmujące wyszukiwanie twórców, linki, bezpieczeństwo, recenzje i więcej.',
    readMore: 'Przeczytaj poradnik',
    backHome: 'Wróć do strony głównej',
  },
  finalCta: {
    title: 'Gotowy, aby poznać zasoby USFans Spreadsheet?',
    copy: 'Zacznij od USFans Spreadsheet i odkryj przydatne poradniki, porównania i zasoby z jednego zorganizowanego centrum.',
    ctaPrimary: 'Poznaj USFans Spreadsheet',
    ctaSecondary: 'Odwiedź główną stronę',
  },
  footer: {
    tagline: 'USFansLink to niezależny zasób informacyjny. Linki, informacje i usługi stron trzecich mogą się z czasem zmieniać.',
    disclaimer: 'Użytkownicy powinni samodzielnie weryfikować ważne informacje i przestrzegać odpowiednich zasad bezpieczeństwa online.',
    navTitle: 'Przeglądaj',
    navLinks: ['Strona główna', 'Spreadsheet', 'Twórcy', 'Poradniki', 'Bezpieczeństwo'],
    legalTitle: 'Prawne',
    legalLinks: ['O nas', 'Prywatność', 'Regulamin', 'Zastrzeżenia', 'Kontakt'],
    categoriesTitle: 'Kategorie',
    copyright: 'Wszelkie prawa zastrzeżone.',
  },
};